import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseActivateVersionRequest, UseActivateVersionData, UseCreateTemplate1Request, UseCreateTemplate1Data, UseRevokeConsentRequest, UseRevokeConsentData, UseSignConsentRequest, UseSignConsentData } from "@api/@types/consent";

export const useActivateVersion = createApiMutation<UseActivateVersionData, UseActivateVersionRequest>({
  mutationFn: (req) => apiClientManager.apis.consent.activateVersion(req as UseActivateVersionRequest),
});

export const useCreateTemplate1 = createApiMutation<UseCreateTemplate1Data, UseCreateTemplate1Request>({
  mutationFn: (req) => apiClientManager.apis.consent.createTemplate1(req as UseCreateTemplate1Request),
});

export const useRevokeConsent = createApiMutation<UseRevokeConsentData, UseRevokeConsentRequest>({
  mutationFn: (req) => apiClientManager.apis.consent.revokeConsent(req as UseRevokeConsentRequest),
});

export const useSignConsent = createApiMutation<UseSignConsentData, UseSignConsentRequest>({
  mutationFn: (req) => apiClientManager.apis.consent.signConsent(req as UseSignConsentRequest),
});

export type { UseActivateVersionRequest, UseActivateVersionData, UseCreateTemplate1Request, UseCreateTemplate1Data, UseRevokeConsentRequest, UseRevokeConsentData, UseSignConsentRequest, UseSignConsentData } from "@api/@types/consent";
